import { markRaw } from 'vue';
import SettingsTagsSection from '@/features/people-tags/components/SettingsTagsSection.vue';
import SettingsAccountSection from '../components/sections/SettingsAccountSection.vue';
import SettingsExecutivesSection from '../components/sections/SettingsExecutivesSection.vue';
import SettingsDepartmentsSection from '../components/sections/SettingsDepartmentsSection.vue';
import SettingsSubDepartmentsSection from '../components/sections/SettingsSubDepartmentsSection.vue';
import SettingsTeamsSection from '../components/sections/SettingsTeamsSection.vue';
import SettingsGradesSection from '../components/sections/SettingsGradesSection.vue';
import SettingsCountriesSection from '../components/sections/SettingsCountriesSection.vue';
import SettingsLocationsSection from '../components/sections/SettingsLocationsSection.vue';
import SettingsEmploymentReferenceSection from '../components/sections/SettingsEmploymentReferenceSection.vue';
import SettingsPositionsSection from '../components/sections/SettingsPositionsSection.vue';
import SettingsRecycleBinSection from '../components/sections/SettingsRecycleBinSection.vue';

/**
 * Workspace administration sections (Settings modal sidebar).
 * Nav order follows mock organogram Settings (Employees omitted; Positions is prod-only).
 * Account is available to every signed-in user (personal settings / Telegram).
 */
export const settingsSections = [
  { key: 'tags', label: 'Tags', icon: 'pi-tags', subtitle: 'People labels and visibility', component: markRaw(SettingsTagsSection) },
  {
    key: 'executives',
    label: 'Executives',
    icon: 'pi-id-card',
    subtitle: 'C-Level roster (read-only)',
    requiredAnyPermission: ['org.view', 'employees.view.global'],
    component: markRaw(SettingsExecutivesSection),
  },
  {
    key: 'departments',
    label: 'Departments',
    icon: 'pi-building',
    subtitle: 'Department structure and appearance',
    requiredAnyPermission: ['departments.manage.global'],
    component: markRaw(SettingsDepartmentsSection),
  },
  {
    key: 'subDepartments',
    label: 'Sub-departments',
    icon: 'pi-sitemap',
    subtitle: 'Organizational units within departments',
    requiredAnyPermission: ['org.manage_sub_departments'],
    component: markRaw(SettingsSubDepartmentsSection),
  },
  {
    key: 'teams',
    label: 'Teams',
    icon: 'pi-users',
    subtitle: 'Teams and team leads',
    requiredAnyPermission: ['org.manage_teams'],
    component: markRaw(SettingsTeamsSection),
  },
  {
    key: 'grades',
    label: 'Grades',
    icon: 'pi-chart-bar',
    subtitle: 'Staff grading levels',
    requiredAnyPermission: ['org.manage_grades'],
    component: markRaw(SettingsGradesSection),
  },
  {
    key: 'countries',
    label: 'Countries',
    icon: 'pi-globe',
    subtitle: 'Names used by work sites and employee profiles',
    requiredAnyPermission: ['org.manage_locations'],
    component: markRaw(SettingsCountriesSection),
  },
  {
    key: 'locations',
    label: 'Locations',
    icon: 'pi-map-marker',
    subtitle: 'Offices and work sites',
    requiredAnyPermission: ['org.manage_locations'],
    component: markRaw(SettingsLocationsSection),
  },
  {
    key: 'employmentReference',
    label: 'Employment',
    icon: 'pi-id-card',
    subtitle: 'Employment types and employing companies',
    requiredAnyPermission: ['org.manage_employment_reference'],
    component: markRaw(SettingsEmploymentReferenceSection),
  },
  {
    key: 'positions',
    label: 'Positions',
    icon: 'pi-briefcase',
    subtitle: 'Job titles and position records',
    requiredAnyPermission: ['positions.create.global', 'positions.update.global'],
    component: markRaw(SettingsPositionsSection),
  },
  {
    key: 'recycleBin',
    label: 'Recycle Bin',
    icon: 'pi-trash',
    subtitle: 'Restore or permanently purge soft-deleted employees',
    requiredAnyPermission: ['employees.delete.global'],
    component: markRaw(SettingsRecycleBinSection),
  },
  {
    key: 'account',
    label: 'Account',
    icon: 'pi-user',
    subtitle: 'Your profile, access, and notification settings',
    availableToAll: true,
    component: markRaw(SettingsAccountSection),
  },
];

export const getSettingsSectionByKey = (key) =>
  settingsSections.find((section) => section.key === key) || null;
